import { userInfo } from '@apollo-internal/cache';
import { useReactiveVar } from '@apollo/client';
import { ISACA_MDDAP_APPRAISER } from '../../../../../constants/system-roles';
import SUPPLEMENTAL_ROLE from '../../../../../constants/supplemental-Roles';

const useATLRoleInfo = () => {
  const currentUserInfo = useReactiveVar(userInfo);

  return {
    isUserATL: isUserATL(currentUserInfo.SystemRole.Id, currentUserInfo.SupplementalRole?.Id),
    isUserATLActingAsATM: (atlId, atlObserverId) =>
      isUserATLActingAsATM(
        currentUserInfo.SystemRole.Id,
        currentUserInfo.SupplementalRole?.Id,
        currentUserInfo.Id,
        atlId,
        atlObserverId
      )
  };
};

const isUserATLActingAsATM = (systemRoleId, supplementalRoleId, userId, atlId, atlObserverId) => {
  if (!isUserATL(systemRoleId, supplementalRoleId)) {
    return null;
  }

  return userId !== atlId && userId !== atlObserverId;
};

const isUserATL = (systemRoleId, supplementalRoleId) =>
  systemRoleId === ISACA_MDDAP_APPRAISER && supplementalRoleId === SUPPLEMENTAL_ROLE.ATL;

export default useATLRoleInfo;
